import { Component } from '@angular/core';
import { FirstUseSlidesService } from '@pages/control-page/control-page-first-use-slides/first-use-slides.service';

@Component({
  selector: 'app-first-use-slide-multi-products',
  templateUrl: './first-use-slide-multi-products.component.html',
  styleUrls: ['./first-use-slide-multi-products.component.scss']
})
export class FirstUseSlideMultiProductsComponent {

  constructor(
    private firstUseSlidesService: FirstUseSlidesService,
  ) {}

  close() {
    this.firstUseSlidesService.registerCloseFirstUseSlides();
  }

}
